import api from '@/services/api'

export async function getNBoxes() {
    try {
        const resp = await api.get('/n-boxes', {
            params: {
                with: 'periods',
                search: 'is_active:1',
            },
        })
        return resp.data.data
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const getQuadrants = async (nBoxId, params) => {
    try {
        const resp = await api.post(`n-boxes/${nBoxId}/matrix`, params)
        return resp.data.data
    } catch (e) {
        console.error(e)
    }
}

export const createComment = async data => {
    try {
        const resp = await api.post('n-box-comments', {
            ...data,
            load: 'valuer',
            only: 'id;content;created_at;valuer_id;valuer.name',
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const updateComment = async (id, data) => {
    try {
        const resp = await api.put(`n-box-comments/${id}`, data)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const deleteComment = async id => {
    try {
        const resp = await api.delete(`n-box-comments/${id}`)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getUserNBoxComments = async (nBoxId, userId) => {
    try {
        const resp = await api.get('n-box-comments', {
            params: {
                with: 'valuer',
                filter: 'id;content;updated_at;valuer_id;valuer.name',
                search: `n_box_id:${nBoxId};evaluated_id:${userId}`,
                and: 'yes',
                orderBy: 'updated_at',
                sortedBy: 'desc',
            },
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
